const MediaMarketingTypeEnum = Object.freeze({
    APPLICATION: 'APPLICATION',
    // Had to change this from KID to KEY_INFORMATION_DOCUMENT to sync with backend
    KID: 'KEY_INFORMATION_DOCUMENT',
    DD: 'DD',
    IM: 'IM',
    CERTIFICATION: 'CERTIFICATION',
    SUMMARY: 'SUMMARY',
    // For single companies:
    INVESTMENT_DECK: 'INVESTMENT_DECK',
    //
    OTHER: 'OTHER',
    SUSTAINABLE_DISCLOSURE: 'SUSTAINABLE_DISCLOSURE'
});

export default MediaMarketingTypeEnum;
